import { useMerchant } from "@/hooks/useMerchant";
import { useQuery } from "@tanstack/react-query";
import { useProtectTRPC } from "../trpc";

export function useChangeRules() {
  const trpc = useProtectTRPC();
  const { merchant } = useMerchant();

  const { data } = useQuery({
    ...trpc.contracts.changeRules.queryOptions({
      rentalsMerchantId: merchant?.id ?? "",
    }),
    enabled: !!merchant?.id,
  });

  return data;
}
